import { useLeadDetailsModalStore } from '@forwardflow/store/modal/LeadDetailsModal'
import { Button } from '@forwardflow/ui'
import Icon from '@forwardflow/ui/Icons'
import { Modal, Skeleton } from 'antd'
import { CurrentConversionStats } from './CurrentConversionStats'
import { AgentsWithMostContracts } from './AgentsWithMostContracts'
import { WorkingHours } from './WorkingHours'
import { useCampaignDetailsByLeadSource } from '@forwardflow/features/campaign'
import { ProjectedRates } from './ProjectedRates'
import { useNavigate } from 'react-router-dom'
import { formatNumber } from '@forwardflow/helpers/utils/formatNumber'
import { LeadsNurturedIcon } from '@forwardflow/assets/svg/LeadsNurturedIcon'
import { ContractIcon } from '@forwardflow/assets/svg/ContractIcon'
import CampaignService from '@forwardflow/services/CampaignService'

export interface CampaignDetails {
   totals: {
      [key: string]: number
   }
   analytics: {
      [key: string]: number
   }
}

export const LeadDetailsModal = () => {
   const {
      isLeadDetailsModalOpen,
      closeLeadDetailsModal,
      campaignName,
      statType,
   } = useLeadDetailsModalStore()
   const { data, isLoading } = useCampaignDetailsByLeadSource(
      campaignName || '',
      statType
   )

   const navigate = useNavigate()

   const handleCampaignCreation = async () => {
      if (campaignName) {
         try {
            const responseActiveLeadSource: any =
               await CampaignService.createActiveLeadSource(
                  campaignName as string
               )
            if (responseActiveLeadSource && responseActiveLeadSource.id) {
               navigate(
                  `/campaign/${encodeURIComponent(
                     responseActiveLeadSource.id
                  )}/phone-number?campaignName=${campaignName}`
               )
            }
         } catch (error) {
            console.error('Error creating campaign:', error)
         }
      }
   }

   return (
      <>
         <Modal
            className={`ff-modal !w-[800px] my-4 ${!isLoading ? 'p-0' : ''}`}
            title=""
            open={isLeadDetailsModalOpen}
            onCancel={closeLeadDetailsModal}
            footer={null}
            closeIcon={false}
            centered
         >
            {!isLoading ? (
               <div>
                  <div className="flex items-center justify-between py-3 border-b border-white/20 px-11 min-h-20">
                     <p className="text-[20px] font-medium">{campaignName}</p>
                     <div className="flexc gap-x-4">
                        <Button
                           onClick={() => handleCampaignCreation()}
                           className="!w-[200px] flexc gap-x-2 !mt-0 !rounded"
                        >
                           <Icon name="TourIcon" />
                           <span>Start Campaign</span>
                        </Button>
                        <div
                           onClick={closeLeadDetailsModal}
                           className="cursor-pointer group"
                        >
                           <Icon
                              name="Close"
                              className="fill-[#818181] group-hover:fill-[#818181]/80"
                           />
                        </div>
                     </div>
                  </div>
                  <div className="mt-5 px-11">
                     <div className="mb-4">
                        {/* <div className="flex h-[220px] relative">
                           <div className="flex-1 py-5 px-7">
                              <p className="text-white/70 text-[14px] font-medium mb-1">
                                 New leads
                              </p>
                              <p className="text-[20px] font-medium">
                                 {
                                    formatNumber(data?.campaignStats?.topMetrics?.current
                                       .totalLeads)
                                 }
                              </p>
                           </div>
                           <div className="flex-1 py-5 px-7">
                              <p className="text-white/70 text-[14px] font-medium mb-1">
                                 Appointments
                              </p>
                              <p className="text-[20px] font-medium">
                                 {
                                    formatNumber(data?.campaignStats?.topMetrics?.current
                                       .totalAppointments)
                                 }
                              </p>
                           </div>
                           <div className="flex-1 py-5 px-7">
                              <p className="text-white/70 text-[14px] font-medium mb-1">
                                 Contracts
                              </p>
                              <p className="text-[20px] font-medium">
                                 {
                                    formatNumber(data?.campaignStats?.topMetrics?.current
                                       .totalContracts)
                                 }
                              </p>
                           </div>
                           <ActiveLeadConversationChart
                              data={data?.campaignStats?.topMetrics}
                           />
                        </div> */}
                        {data?.campaignStats?.topMetrics?.current &&
                           (data.campaignStats.topMetrics.current.totalLeads ||
                              data.campaignStats.topMetrics.current
                                 .totalAppointments ||
                              data.campaignStats.topMetrics.current
                                 .totalContracts) && (
                              <div className="relative flex overflow-hidden rounded h-52 bg-primary/30">
                                 <div className="flex-col flex-1 py-5 text-center border-r border-white/20 px-7 flexc">
                                    <div className="h-[38px] w-[38px] flexc shrink-0 mb-5">
                                       <LeadsNurturedIcon
                                          className="mx-auto"
                                          width={38}
                                          height={38}
                                       />
                                    </div>
                                    <p className="text-white/70 text-[14px] font-medium mb-1">
                                       Leads nurtured
                                    </p>
                                    <p className="text-[32px] font-medium">
                                       {formatNumber(
                                          data?.campaignStats?.topMetrics
                                             ?.current.totalLeads
                                       ) || 'N/A'}
                                    </p>
                                 </div>
                                 <div className="flex-col flex-1 py-5 text-center border-r flexc border-white/20 px-7">
                                    <div className="h-[38px] w-[38px] mb-5 flexc shrink-0 ">
                                       <Icon
                                          name="Calendar"
                                          className="mx-auto fill-[#AB7AE0] scale-[1.9]"
                                       />
                                    </div>

                                    <p className="text-white/70 text-[14px] font-medium mb-1">
                                       Appointments
                                    </p>
                                    <p className="text-[32px] font-medium">
                                       {formatNumber(
                                          data?.campaignStats?.topMetrics
                                             ?.current.totalAppointments
                                       ) || 'N/A'}
                                    </p>
                                 </div>
                                 <div className="flex-col flex-1 py-5 text-center px-7 flexc">
                                    <div className="h-[38px] w-[38px] flexc shrink-0 mb-5">
                                       <ContractIcon
                                          className="mx-auto"
                                          width={38}
                                          height={38}
                                       />
                                    </div>

                                    <p className="text-white/70 text-[14px] font-medium mb-1">
                                       Contracts
                                    </p>
                                    <p className="text-[32px] font-medium">
                                       {formatNumber(
                                          data?.campaignStats?.topMetrics
                                             ?.current.totalContracts
                                       ) || 'N/A'}
                                    </p>
                                 </div>
                              </div>
                           )}
                     </div>
                     <CurrentConversionStats
                        conversionRatePercent={
                           data?.campaignStats?.conversionStats
                              ?.conversionRatePercent ?? 0
                        }
                        avgSpeedToAction={
                           data?.campaignStats?.conversionStats
                              ?.avgSpeedToAction ?? 0
                        }
                        responseRatePercent={
                           data?.campaignStats?.conversionStats
                              ?.responseRatePercent ?? 0
                        }
                     />
                     <ProjectedRates
                        conversionRatePercent={
                           data?.campaignStats?.projectedConversionStats
                              ?.conversionRatePercent ?? {
                              projected: 0,
                              changeInPercent: 0,
                           }
                        }
                        avgSpeedToAction={
                           data?.campaignStats?.projectedConversionStats
                              ?.avgSpeedToAction ?? {
                              projected: '',
                              change: '',
                           }
                        }
                        responseRatePercent={
                           data?.campaignStats?.projectedConversionStats
                              ?.responseRatePercent ?? {
                              projected: 0,
                              changeInPercent: 0,
                           }
                        }
                     />
                     <div className="flex pb-4 gap-x-3">
                        {data?.agentsWithMostContracts &&
                           data.agentsWithMostContracts.length > 0 && (
                              <div className="flex-1">
                                 <AgentsWithMostContracts
                                    agentsWithMostContracts={
                                       data?.agentsWithMostContracts || []
                                    }
                                    direction="col"
                                 />
                              </div>
                           )}
                        <div className="flex-1">
                           <WorkingHours
                              bestTime={data?.bestTimeRange}
                              callSummary={data?.callSummary}
                           />
                        </div>
                     </div>
                  </div>
               </div>
            ) : (
               <div className="flexc">
                  <Skeleton active />
               </div>
            )}
         </Modal>
      </>
   )
}
